import { AfterViewInit, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'chassis-modal-backdrop',
    templateUrl: './backdrop.component.html',
    styleUrls: [ './backdrop.component.scss' ]
})
export class ModalBackdrop implements AfterViewInit {

    /**
     * Add class attribute to the host element.
     *
     * @type {string}
     */
    @HostBinding('class') classes = 'modal-backdrop fade show';

    /**
     * Add z-index attribute to the host element.
     *
     * @type {string}
     */
    @HostBinding('style.z-index') @Input() zIndex;

    ngAfterViewInit() {
        setTimeout(() => {
            this.classes = this.classes.concat(' in');
        }, 0);
    }

}




// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/components/backdrop/backdrop.component.ts